import Swiper from "swiper";
import { FreeMode, Mousewheel, Pagination } from "swiper/modules";

export default class BODSlider {
	constructor(el) {
		this.el = el;
		this.init();
	}

	init() {
		this.pagination = this.el.querySelector(".swiper-pagination");

		this.swiper = new Swiper(this.el, {
			slidesPerView: 1,
			spaceBetween: 30,
			modules: [Pagination, FreeMode, Mousewheel],
			pagination: {
				el: this.pagination,
			},
			breakpoints: {
				576: {
					slidesPerView: "auto",
					pagination: false,
					mousewheel: {
						enabled: true,
						sensitivity: 2,
					},
					freeMode: {
						enabled: true,
						momentumBounce: false,
					},
					allowTouchMove: false,
				},
			},
		});
	}
}
